export default __webpack_public_path__ + "static/media/logo-ae-emax.7968cfb2.svg";